import { Component } from '@angular/core';
import { IconComponent } from '../../shared';
import { FAQ } from '../../content/home.content';

@Component({
  selector: 'app-faq',
  imports: [IconComponent],
  templateUrl: './faq.component.html'
})
export class FaqComponent {
  readonly content = FAQ;
}
